import get from 'lodash.get';

const getPrivacyPolicyUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.privacyPolicyUrl', null);

export default getPrivacyPolicyUrl;
